export default "__VITE_ASSET__3e4f630b__"